import { Box, Container, Typography } from "@mui/material";
import React, { useEffect } from "react";
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/Navbar/Navbar";
import IDesignCaseStudy from "../../Assets/Images/PortfolioImages/idesign_2x.webp";
import IDesignCaseStudyBanner from "../../Assets/Images/PortfolioImages/idesignbanner.webp";
import Bgimage from "../HomePage/Bgimagesection/Bgimage";
import { Helmet } from "react-helmet-async";

function Idesigncasestudy() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the window to the top when the component mounts
  }, []);

  return (
    <div style={{ background: "#181818" }}>
      <Helmet>
        <title>i-Design Case Study | Custom Fashion Design App - Dwebbox</title>
        <meta
          name="description"
          content="Discover how Dwebbox developed i-Design, an innovative custom apparel design application allowing users to personalize fabrics, measurements, and styles."
        />
        <meta name="keywords" content="i-Design case study, custom apparel app, fashion technology, mobile app design, Dwebbox" />
        <link rel="canonical" href="https://dwebbox.com/iDesignCasestudy" />
      </Helmet>
      <Navbar />
      <Box sx={{ width: "100%", background: "#181818" }}>
        <Container
          component="main"
          sx={{
            pt: 10,
            background: "#181818",
            "@media (max-width:600px)": {
              // Styles for screens with a maximum width of 600px (mobile view)
              paddingTop: "40px",
            },
          }}
        >
          <Typography
            paragraph
            sx={{
              color: "#ffffff",
              fontSize: "20px",
              fontFamily: "DM Sans_18pt-ExtraLight",
              "@media (max-width:600px)": {
                // Styles for screens with a maximum width of 600px (mobile view)
                fontSize: "18px",
              },
            }}
          >
            <span
              style={{
                content: "''",
                display: "inline-block",
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                background: "white",
                marginRight: "5px",
              }}
            ></span>{" "}
            Portfolio {/* Add a span with the bullet class */}
          </Typography>
          <Typography
            variant="h1"
            sx={{
              color: "#ffffff",
              display: "flex",
              alignItems: "center",
              fontSize: "70px",
              fontFamily: "Epilogue",
              fontWeight: "600",
              "@media (max-width:600px)": {
                // Styles for screens with a maximum width of 600px (mobile view)
                fontSize: "24px",
              },
            }}
          >
            I-Design
          </Typography>
        </Container>
      </Box>
      <Box sx={{ width: "100%", background: "#181818" }}>
        <Container
          component="main"
          sx={{
            pt: 10,
            pb: 10,
            background: "#181818",
            "@media (max-width:700px)": {
              // Styles for screens with a maximum width of 600px (mobile view)
              pt: 5,
              pb: 5,
            },
          }}
        >
          <Box>
            <img src={IDesignCaseStudyBanner} width="100%" alt="" />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              background: "rgba(34, 34, 34, 1)",
              height: "20vh",
              marginTop: "20vh",
              "@media (max-width:700px)": {
                // Styles for screens with a maximum width of 600px (mobile view)
                flexDirection: "column",
                height: "30vh",
                marginTop: "5vh",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "30%",
                color: "rgba(255, 255, 255, 1)",
                "@media (max-width:700px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  width: "60%",
                  marginTop: "5%",
                  height: "33%",
                },
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontFamily: "DM Sans18ptLight",

                  "@media (max-width:700px)": {
                    // Styles for screens with a maximum width of 600px (mobile view)
                    fontSize: "16px",
                  },
                }}
              >
                Industry
              </Typography>
              <Typography
                paragraph
                sx={{
                  fontWeight: "300",
                  fontSize: "20px",
                  fontFamily: "DM Sans18ptLight",

                  "@media (max-width:700px)": {
                    // Styles for screens with a maximum width of 600px (mobile view)
                    fontSize: "14px",
                  },
                }}
              >
                Fashion
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "40%",
                color: "rgba(255, 255, 255, 1)",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontFamily: "DM Sans18ptLight",

                  "@media (max-width:700px)": {
                    // Styles for screens with a maximum width of 600px (mobile view)
                    fontSize: "14px",
                  },
                }}
              >
                Services Provided
              </Typography>
              <Typography
                paragraph
                sx={{
                  fontWeight: "300",
                  fontSize: "20px",
                  fontFamily: "DM Sans18ptLight",

                  "@media (max-width:700px)": {
                    // Styles for screens with a maximum width of 600px (mobile view)
                    fontSize: "14px",
                  },
                }}
              >
                App Development
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "30%",
                color: "rgba(255, 255, 255, 1)",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontFamily: "DM Sans18ptLight",

                  "@media (max-width:700px)": {
                    // Styles for screens with a maximum width of 600px (mobile view)
                    fontSize: "14px",
                  },
                }}
              >
                Year
              </Typography>
              <Typography
                paragraph
                sx={{
                  fontWeight: "300",
                  fontSize: "20px",
                  fontFamily: "DM Sans18ptLight",

                  "@media (max-width:700px)": {
                    // Styles for screens with a maximum width of 600px (mobile view)
                    fontSize: "14px",
                  },
                }}
              >
                2021-2022
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              background: "rgba(34, 34, 34, 1)",
              padding: "5vh",
              marginTop: "10vh",
              "@media (max-width:600px)": {
                // Styles for screens with a maximum width of 600px (mobile view)
                padding: "3vh",
                marginTop: "5vh",
              },
            }}
          >
            <Typography
              variant="h3"
              sx={{
                color: "#ffffff",
                fontSize: "24px",
                marginTop: "5vh",
                fontWeight: "600",
                marginBottom: "3vh",
                fontFamily: "Epilogue",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  fontSize: "20px",
                },
              }}
            >
              The Challenge
            </Typography>
            <Typography
              paragraph
              sx={{
                color: "#ffffff",
                fontSize: "20px",

                fontFamily: "DM Sans_18pt-ExtraLight",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  fontSize: "12px",
                },
              }}
            >
              The fashion industry has long been synonymous with trends, mass
              production, and an overwhelming array of options. But as the
              demand for individuality grows, many customers are seeking
              something beyond just off-the-rack apparel. The challenge,
              however, lies in the ability to cater to these desires.
              Personalized clothing has historically been a niche market, often
              requiring high costs, intricate craftsmanship, and long waiting
              times. Consumers want tailored, stylish options that match their
              personal taste, but the challenge remains: how can brands deliver
              custom apparel at scale while maintaining quality, affordability,
              and convenience?{" "}
            </Typography>
          </Box>

          <Box
            sx={{
              background: "rgba(34, 34, 34, 1)",
              padding: "5vh",
              marginTop: "10vh",
              "@media (max-width:600px)": {
                // Styles for screens with a maximum width of 600px (mobile view)
                padding: "3vh",
                marginTop: "5vh",
              },
            }}
          >
            <Typography
              variant="h3"
              sx={{
                color: "#ffffff",
                fontSize: "24px",
                marginTop: "5vh",
                fontWeight: "600",
                marginBottom: "3vh",
                fontFamily: "Epilogue",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  fontSize: "20px",
                },
              }}
            >
              Approach
            </Typography>
            <Typography
              paragraph
              sx={{
                color: "#ffffff",
                fontSize: "20px",

                fontFamily: "DM Sans_18pt-ExtraLight",
                "@media (max-width:600px)": {
                  // Styles for screens with a maximum width of 600px (mobile view)
                  fontSize: "12px",
                },
              }}
            >
              An innovative solution designed to revolutionize how we shop for
              clothes. By merging technology and creativity, this app allows
              users to design their own garments with ease. From selecting
              fabric textures and colors to adding personalized monograms, users
              are empowered to create clothes that reflect their personality.
              The app’s intelligent algorithm even takes body measurements and
              style preferences into account, ensuring a perfect fit every time.
              This seamless process not only makes the experience more
              accessible and efficient but also fosters a deeper connection
              between the customer and the brand. With this personalized
              approach, fashion is no longer about simply following trends —
              it’s about expressing one’s unique identity with every piece worn.
            </Typography>
          </Box>
        </Container>
      </Box>
      <Box sx={{ background: "#181818" }}>
        <img src={IDesignCaseStudy} alt="" width="100%" />
      </Box>
      <Bgimage />
      <Footer />
    </div>
  );
}

export default Idesigncasestudy;
